/**
 * Created by Ning Jiang on 4/27/2016.
 */

import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { ParsedInitData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import { ServerDataParser } from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import { ISanInitData, SanJumpData } from "./ISanServerData";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class SanParsedInitData extends ParsedInitData {

    private readonly _bottomRowOpen:boolean[];
    private readonly _sanJumpData:SanJumpData[];
    private readonly _scatterReelPositions:number[];
    private readonly _fsSym:{sym:string,val:number};
    private readonly _scatterAmm:number;
    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    public get bottomRowOpen():boolean[]{
        return this._bottomRowOpen;
    }

    public get sanJumpData():SanJumpData[]{
        return this._sanJumpData;
    }

    public get scatterReelPositions():number[]{
        return this._scatterReelPositions;
    }

    public get scatterAmm():number{
        return this._scatterAmm;
    }

    public get fsSym():{sym:string,val:number}{
        return this._fsSym;
    }

    constructor(rawData:ISanInitData, dataParser:ServerDataParser) {
        super(rawData, dataParser);

        if(rawData.specialSymbol){
            const symKey:string = Object.keys(rawData.specialSymbol)[0];
            this._fsSym = {sym:symKey,val:rawData.specialSymbol[symKey]};
        }

        this._sanJumpData = this.jumpDecryption(rawData.stickyWildPositions)
        this._scatterReelPositions = this.findOneSymbol(ReelSymbolName.SCATTER);
        this._scatterAmm = this.countArrayPos(this._scatterReelPositions);
        // rawData.jumpingWilds
        for(let i =0; i < rawData.reels.length; i++)
            this.reels[i] =  this.reels[i].filter(( value:string)=> {return !!value})

        this._bottomRowOpen = rawData.bottomRowOpen;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    private countArrayPos(arr:number[]):number{
        let count:number = 0;
        arr.forEach(val => { if(val >= 0 && val <= 2) count++;});
        return count;
    }

    private findOneSymbol(symbol:string):number[]{
        let arr:number[] = [];

        for(let reel = 0; reel < this.reels.length; reel++){
            let pos:number = -1;
            for(let row:number = 0; row < 3; row++){
                if(this.reels[reel][row+1] == symbol){
                    pos = row;
                    break;
                } 
            }
            arr.push(pos);
        }
        return arr;
    }

    private jumpDecryption(jumpData:string):SanJumpData[]{
        const amountOfJumpers:string[] = jumpData.split(";").filter((s) => { return s });
        const arr:SanJumpData[] = [];
        
        for(let j:number= 0; j < amountOfJumpers.length; j++){
            const splittedData:string[] = amountOfJumpers[j].split(":");
            arr.push( defining(
                pos(splittedData[0]), // Reel
                pos(splittedData[1]), // Row
                [ parseFloat(splittedData[2]),parseFloat(splittedData[3]) // Multi
            ]));
        }

        function defining (from:number[],to:number[],multiplier:number[]):SanJumpData{
            return { 
                from:{ reel:from[0], row:from[1], multiplier:multiplier[0]} ,
                to: { reel:to[0], row:to[1], multiplier:multiplier[1]} };
        }
        
        function pos (val:string):number[]{
             return val.split(",").map((s:string) => { if(parseFloat(s) < 0 ) return 0; return parseFloat(s)});
         }

        return arr;
    }
}